import {FormattedMessage} from "react-intl";
import {PulsatingHeart} from "@commons/uinew/domaincomponent/svg";
import React from "react";
import {CustomFormattedMessage} from "@commons/infra/component/CustomFormattedMessage";
import LocalizedLink from "@commons/infra/i18n/LocalizedLink";
import {PublicLinks} from "../../../../../../portal-latvia/src/utility/links";

export let AboutUsBanner = () => {
    return <div
        className={"bg-secondary rounded-3 px-4 pb-md-0 py-4 my-4 my-md-4 d-flex flex-column flex-md-row align-content-center align-items-center"}>

        <div className={"order-1 pe-md-3"}>
            <h4>
                <FormattedMessage id={"pages.about.story.title"}/>
                <PulsatingHeart className={"ms-2"}/>
            </h4>
            <p>
                <CustomFormattedMessage id={"promotion.about-us-banner.text"}/>
            </p>
            <LocalizedLink to={PublicLinks.doctors()} className={"btn btn-primary btn-sm mb-md-3"}>
                <FormattedMessage id={"promotion.about-us-banner.button-text"}/>
                <i className={"ai ai-arrow-right ms-2"}/>
            </LocalizedLink>
        </div>

        <div className={"order-0 order-md-2 flex-shrink-0 pb-3 pb-md-0 d-none d-md-block"}>
            <img alt="Lady with phone" className={"rounded-3"} src={"/img/promo-modal/lady-with-phone-2.png"}/>
        </div>

    </div>
}